import { FETCH_LINKED_ACCOUNTS_FAILURE, FETCH_LINKED_ACCOUNTS_BEGIN, FETCH_LINKED_ACCOUNTS_SUCCESS, TOGGLE_IS_ACTIVE, FETCH_LINKED_USERS_SUCCESS, FETCH_LINKED_USERS_FAILURE, FETCH_LINKED_USERS_BEGIN} from "../actions/linkedAccountsInfoActions";

const initialState = {
    accounts: [],
    loading: false,
    error: null,
    isActive: true,
    linkedUsers: []
};

export function linkedAccountsReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_LINKED_ACCOUNTS_BEGIN:
            return {
                ...state,
                loading: true,
                error: null
            };

        case FETCH_LINKED_ACCOUNTS_SUCCESS:
            return {
                ...state,
                loading: false,
                accounts: action.payload.accounts
            };


        case FETCH_LINKED_USERS_BEGIN:
            return {
                ...state,
                loading: true,
                error: null
            };

        case FETCH_LINKED_USERS_SUCCESS:
            return {
                ...state,
                loading: false,
                linkedUsers: action.payload.users
            };
        case FETCH_LINKED_ACCOUNTS_FAILURE:
        case FETCH_LINKED_USERS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                accounts: action.type === FETCH_LINKED_ACCOUNTS_FAILURE ? [] : state.accounts,
                linkedUsers: action.type === FETCH_LINKED_USERS_FAILURE ? [] : state.linkedUsers
            };

        case TOGGLE_IS_ACTIVE:
            return {
                ...state,
                isActive: action.payload,
            };

        default:
            return state;
    }
}